<template lang="pug" src="./index.pug"></template>
<style lang="scss" src="./index.scss" scoped></style>

<script>
import scroll from '@/utils/scroll'

import { mapState } from 'vuex'

export default {
    data: () => ({
        filters: {
            fromDate: null,
            toDate: null,
            email: null,
            name: null
        },
        sorting: {}
    }),
    computed: {
        ...mapState({
            customers: state => state.customers.customers,
            isTableLoad: state => state.customers.isLoaded,
            pagination: state => state.customers.pagination,
            appliedFilters: state => state.customers.filters
        }),
        headers: function() {
            return [
                { text: 'phoneNumber', value: '"phone"."phoneNumber"' },
                { text: 'lastName', value: '"lastName"' },
                { text: 'firstName', value: '"firstName"' },
                { text: 'email', value: '"email"' },
                { text: 'appVersion', value: '"appVersion"' },
                { text: 'createdAt', value: '"createdAt"' },
                { text: 'actions', sortable: false }
            ].map(it => Object.assign(it, {
                text: this.$vuetify.t(`$vuetify.pages.Admins.table.${it.text}`)
            }))
        }
    },
    watch: {
        sorting: {
            handler() {
                this.getCustomersByPage()
            },
            deep: true
        }
    },
    created: function() {
        this.filters = Object.assign({}, this.appliedFilters)
        this.getCustomersByPage(this.pagination.page)
    },
    beforeRouteLeave: function(to, from, next) {
        this.$store.commit('customers/SET_PAGINATION', { page: 1, length: null })
        next()
    },
    methods: {
        submit() {
            this.$store.commit('customers/SET_FILTERS', Object.assign({}, this.filters))
            this.getCustomersByPage()
        },
        reset() {
            this.filters = Object.assign({}, {
                fromDate: new Date(+new Date() - 31556926000).toISOString().split('T')[0],
                toDate: null
            })
            this.$store.commit('customers/RESET_FILTERS')
            this.getCustomersByPage()
        },
        getCustomersByPage(page = 1, isScrollEnable = false, excel = false) {
            this.$store.dispatch('customers/getCustomers', {
                excel,
                page,
                column: this.sorting.sortBy,
                direction: this.sorting.descending ? 'desc' : 'asc',
                ...this.appliedFilters
            }).then(_ => {
                if (isScrollEnable) {
                    scroll(this.$refs.table)
                }
            })
        },
        changeToDate(date) {
            this.filters.toDate = date
        },
        changeFromDate(date) {
            this.filters.fromDate = date
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.getCustomersByPage(page, true)
            }
        },
        openEditor(id) {
            this.$router.push(`customers/${id}`)
        },
        resetLoginAttempts(phoneNumber) {
            this.$store.dispatch('customers/resetLoginAttempts', {
                phoneNumber
            })
        },
        exportToExcel() {
            this.getCustomersByPage(1, false, true)
        }
    }
}
</script>
